// Maps detection description names (from detections.json surveyed[].description)
// to the canonical ItemDefinition names used in the moving inventory.
export const DETECTION_ITEM_DEF_MAP: Record<string, string> = {
  Chair: 'Chair, Dining',
  'Coffee table': 'Table, Coffee / End',
  'Dining Table': 'Table, Dining',
  Houseplant: 'Plant, Artificial',
  Pillow: 'Cushion',
  Sofa: 'Sofa, 3 Cushion',
  Television: 'Large Flat Screen TV',
};
